export const ProductCategories = [
  {
    labels: "Smartphones",
  },
  {
    labels: "Laptops",
  },
  {
    labels: "DSLR Cameras",
  },
  {
    labels: "Televisions",
  },
  {
    labels: "Air Conditioners",
  },
  {
    labels: "Refrigerators",
  },
  {
    labels: "Kitchen Appliances",
  },
  {
    labels: "Accessories",
  },
  {
    labels: "Personal Care & Grooming",
  },
];

export const SiteInfo = [
  {
    labels: "About Reliance Digital",
  },
  {
    labels: "resQ Services",
  },
  {
    labels: "Site Map",
  },
  {
    labels: "Gift Cards",
  },
  {
    labels: "Corporate Enquires",
  },
  {
    labels: "Contact Us",
  },
];

export const ResourcesCenter = [
  {
    labels: "Product Reviews",
  },
  {
    labels: "Buying Guides",
  },
  {
    labels: "How Tos",
  },
  {
    labels: "Featured Stories",
  },
  {
    labels: "Events & Happenings",
  },
];

export const Policies = [
  {
    labels: "Terms of Use",
  },
  {
    labels: "FAQs",
  },
  {
    labels: "Cancellation and Return Policy",
  },
  {
    labels: "Pricing and Payments Policy",
  },
  {
    labels: "Shipping and Delivery Policy",
  },
  {
    labels: "Privacy Policy",
  },
  {
    labels: "E-waste Recycling Policy",
  },
  {
    labels: "EMI and Additional Cashback T&C",
  },
  {
    labels: "RelianceOne Loyalty Program T&C",
  },
  {
    labels: "Caution Notice",
  },
];
